import { HTMLAttributes } from 'react'
import styled from 'styled-components'
import { compose, color, space, layout, flexbox, border, shadow } from 'styled-system'
import { SystemProps } from '../theme'
import { Box } from '../box'

type Props = SystemProps & HTMLAttributes<any>

export type CardProps = Props

export const Card = styled(Box)<Props>(compose(layout, space, color, flexbox, border, shadow))

Card.defaultProps = {
  boxShadow: 'shadow-bevel-neutral-default',
  p: 4,
  borderRadius: 8,
  bg: 'white',
}
